import React from 'react';
import CrudTable from '../table/crudtable'
import { announcementService, authService } from '../../_services'
import AnnouncementForm from './announcementform.component'
import { useTranslation } from "react-i18next";
import moment from 'moment'

function AnnouncementList() {

	const {t} = useTranslation('common');

	const initialState = {
		customerId: -1,
		type: 'PRIMARY',
		translations: { SV: '', EN: '' },
		broadcast: true,
		dismissible: true,
		startDate: null,
		endDate: null,
		users: [],
		devices: [],
		platforms: ['WEB', 'ANDROID', 'IOS']
	}

    const formatBoolean = function(cell) {
		return cell ? t('crudtable.yes') : t('crudtable.no')
    }

    const formatDateCreated = function(cell, row) {
        return <a href={'/announcement/' + row.id}>
            {moment(cell).format('yyyy-MM-DD HH:mm')}
        </a>
	}

    const formatDate = function(cell) {
        if (cell) {
            return moment(cell).format('yyyy-MM-DD HH:mm')
        }
		return '-'
	}

	const formatTranslations = function(cell, row) {
		return <div style={{maxWidth: 600}}>
			{ Object.entries(cell).map((entry, index) => {
				return <div key={row.id + '-' + entry[0]} style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
					{entry[0] + ': ' + entry[1]}
				</div>
			})}
		</div>
    }

    const columns = [
	    {
			dataField: 'dateCreated',
			text: t('announcement.columns.datecreated'),
			formatter: formatDateCreated,
			sort: true
	    },
	    {
			dataField: 'customerName',
			text: t('announcement.columns.customer'),
			formatter: (cell) => cell || '-',
			sort: true,
			hidden: !authService.hasRoles(['ROLE_SUPER_ADMIN'])
	    },
	    {
			dataField: 'type',
			text: t('announcement.columns.type'),
			formatter: (cell) => cell || '-',
			sort: true
	    },
	    {
			dataField: 'translations',
			text: t('announcement.columns.translations'),
			formatter: formatTranslations
	    },
	    {
			dataField: 'broadcast',
			text: t('announcement.columns.broadcast'),
			formatter: formatBoolean,
			sort: true
	    },
	    {
			dataField: 'platforms',
			text: t('announcement.columns.platforms'),
			formatter: (cell) => cell.join(', '),
			sort: true
	    },
	    {
			dataField: 'startDate',
			text: t('announcement.columns.startdate'),
			formatter: formatDate,
			sort: true
	    },
	    {
			dataField: 'endDate',
			text: t('announcement.columns.enddate'),
			formatter: formatDate,
			sort: true
	    },
	]

    return (
		<div>
            <h2>
                {t('announcement.label')}
            </h2>
            <CrudTable
		        service={announcementService}
		        columns={columns}
		        initialState={initialState}
		        form={<AnnouncementForm />}
		        sort={{dataField: 'dateCreated', order: 'desc'}}
		        modalSize="lg"
		        creatable={authService.hasRoles(['ROLE_ANNOUNCEMENT_WRITE'])}
				editable={authService.hasRoles(['ROLE_ANNOUNCEMENT_WRITE'])}
				deletable={authService.hasRoles(['ROLE_ANNOUNCEMENT_WRITE'])}
		        urlParams={true}
            />
        </div>
    )
}

export default AnnouncementList;